<!-- Ported from the Polaris kit: src/product/components/SuggestedRules.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first.
     Hand changes (phase 4.4):
     - An item can be a string (the kit: a rule) or an object with `id`; `itemKey`/`itemText` read the object. A
       default slot (`{ item }`) draws a richer item (a scenario: title, when it applies, the instruction) in the
       item's content; without it, the item's text as the kit does.
     - Events keep the kit's names; `add` carries the item as given (string or object).
     - Words in i18n ("Add all", "Add", the close button, the "Add the rule" name). -->
<script setup>
// Rules the agent suggests, to add with one click each or all together. A dashed frame says they are not rules yet.
import { useI18n } from 'vue-i18n';
import { Add16, Close16 } from '@carbon/icons-vue';
import { Button } from '../ui/button';
import { Item, ItemActions, ItemContent } from '../ui/item';

defineProps({
  title: { type: String, required: true },
  items: { type: Array, default: () => [] },
});
const emit = defineEmits(['add', 'add-all', 'close']);
const { t } = useI18n();

const itemText = item =>
  typeof item === 'string' ? item : item.title || item.content || '';
const itemKey = item => (typeof item === 'string' ? item : item.id);
</script>

<template>
  <section
    class="grid min-w-0 grid-cols-1 gap-1 overflow-hidden rounded-polaris-xl border border-dashed border-polaris-border p-2"
    :aria-label="title"
    data-suggested-rules
  >
    <div class="flex items-center gap-2 px-2 pt-2">
      <h3 class="me-auto type-polaris-section-title">{{ title }}</h3>
      <Button type="button" variant="ghost" size="sm" @click="emit('add-all')">
        {{ t('POLARIS.PAGES.SUGGESTED.ADD_ALL') }}
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        :aria-label="t('POLARIS.PAGES.SUGGESTED.DISMISS')"
        @click="emit('close')"
      >
        <Close16 aria-hidden="true" />
      </Button>
    </div>
    <ul role="list" class="m-0 grid list-none gap-1 p-0">
      <li v-for="item in items" :key="itemKey(item)">
        <Item size="sm" class="flex-nowrap">
          <ItemContent class="min-w-0">
            <slot :item="item">
              <p class="type-polaris-body">{{ itemText(item) }}</p>
            </slot>
          </ItemContent>
          <ItemActions class="self-start">
            <Button
              type="button"
              variant="secondary"
              size="sm"
              :aria-label="
                t('POLARIS.PAGES.SUGGESTED.ADD_ONE_LABEL', {
                  item: itemText(item),
                })
              "
              @click="emit('add', item)"
            >
              <Add16 aria-hidden="true" />
              {{ t('POLARIS.PAGES.SUGGESTED.ADD') }}
            </Button>
          </ItemActions>
        </Item>
      </li>
    </ul>
  </section>
</template>
